import React from 'react';
import Hero from '../components/Hero';
import GameCategories from '../components/GameCategories';
import FamousLeagues from '../components/FamousLeagues';
import Turnover from '../components/Turnover';
import SEOContent from '../components/SEOContent';
import Footer from '../components/Footer';

interface LandingPageProps {
  onScrollToSection: (sectionId: string) => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onScrollToSection }) => {
  return (
    <main className="min-h-screen flex-1 w-full overflow-x-hidden">
      <Hero onScrollToSection={onScrollToSection} />
      <GameCategories />
      <FamousLeagues />
      <Turnover />
      <SEOContent />
      <Footer />
    </main>
  );
};

export default LandingPage; 